import script from "./ContentWidgetPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentWidgetPopup.vue?vue&type=script&setup=true&lang=js"

import "./ContentWidgetPopup.vue?vue&type=style&index=0&id=5fb05d1a&lang=scss"

const __exports__ = script;

export default __exports__